import {globals} from '@extensions/globals-base'
import {Task} from '@extensions/task'
import {TaskItem} from './task-item'

export const processUnseen = async (unseen: TaskItem[]): Promise<void> => {
  const companyId = globals.getCompanyId()
  unseen.forEach(task => {
    const t = {...task, companyId}
    Task.insertInGTD(t, 'new', 'my-tasks -> processUnseen')
  })
}
